<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.0037 3.00012C14.7653 3.00012 17.0037 5.25257 17.0037 8.01906C17.0037 10.7858 14.7654 13.0386 12.0037 13.0386C9.24202 13.0386 7.00375 10.7858 7.00375 8.01906C7.00375 5.25261 9.24211 3.00012 12.0037 3.00012ZM15.1628 14.1516C14.4132 13.842 13.5509 14.0157 12.9797 14.5914L12.0267 15.5501L11.0758 14.5914L10.9578 14.4816C10.3901 13.9947 9.59232 13.8626 8.89272 14.1516C6.67736 15.0665 4.49089 16.4354 3.44007 17.7532C2.39539 19.0632 3.32818 21.0001 5.00375 21.0001H19.0518L19.202 20.9949C20.7821 20.8833 21.6285 19.0235 20.6155 17.7532C19.5646 16.4354 17.3782 15.0665 15.1628 14.1516ZM12.5348 17.8792L14.3994 16.0001L14.7081 16.1313C16.2662 16.8117 18.019 17.8501 18.8971 18.8187L19.0518 19.0001H5.00375L5.15844 18.8187C6.09509 17.7855 8.02693 16.673 9.65616 16.0001L11.5207 17.8792L11.6036 17.9522C11.89 18.1714 12.2691 18.1471 12.5348 17.8792ZM9.00375 8.01906C9.00375 6.35433 10.3496 5.00012 12.0037 5.00012C13.6579 5.00012 15.0037 6.35433 15.0037 8.01906C15.0037 9.62465 13.7524 10.9415 12.1797 11.0335L12.0037 11.0386L11.8277 11.0335C10.2551 10.9415 9.00375 9.62465 9.00375 8.01906Z"
      fill="#3F3F3F"
    />
  </svg>
</template>
